import xws from 'api/xws/';
import { format as formatDate } from 'date-fns';

import { SET_RECALL_SERVICES } from './actionTypes';
import { ERROR_RECALL } from 'store/reducers/errors/actionTypes';
// Actions
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';

// Selectors
import { getVariant, findMake } from 'store/reducers/dealerSettings/selectors';
import { getVehicle } from 'store/reducers/appointment/selectors';
import { getWebkey } from 'store/reducers/queryParams/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';

// Constants
import { getService } from 'constants/ajax';
import { RECALL_CONTROL } from 'constants/recalls';

const { READONLY, NO_CONTRACT, DISABLED } = RECALL_CONTROL;

export const getRecallDeferredServices = () => async (dispatch, getState) => {
  const { vin, make } = getVehicle(getState());
  if (vin) {
    try {
      const variant = getVariant(getState());
      const recallService = getService('recalls');
      const webkey = getWebkey(getState());
      const locale = getLocaleCode(getState());
      recallService.setPathVars({ vin });
      recallService.setCallBacks(dispatch(ajaxCallbacks()));
      const { data } = await xws(recallService).get(recallService.getPath(), {
        params: {
          locale,
          make,
          variant,
          webkey,
          day: formatDate(new Date(), 'YYYY/MM/DD')
        }
      });
      const recallControl = data.recallInfo.recallControl.toUpperCase();
      const recallControlDisabled =
        recallControl === READONLY ||
        recallControl === NO_CONTRACT ||
        recallControl === DISABLED;
      return recallControlDisabled
        ? { ...data, recallInfo: { ...data.recallInfo, autoRecalls: [] } }
        : data;
    } catch (e) {
      dispatch({
        type: ERROR_RECALL,
        payload: true
      });
      /* eslint-disable no-console */
      console.error(e);
      /* eslint-enable no-console */
      return {};
    }
  } else {
    dispatch({
      type: ERROR_RECALL,
      payload: true
    });
    return {};
  }
};

export const hasRecalls = (vin, make) => async (dispatch, getState) => {
  if (vin) {
    try {
      const stateMake = findMake(getState())(make);
      const variant = stateMake.variant;
      const recallService = getService('recalls');
      const webkey = getWebkey(getState());
      const locale = getLocaleCode(getState());
      recallService.setPathVars({ vin });
      recallService.setCallBacks(dispatch(ajaxCallbacks()));
      const {
        data: { recallInfo }
      } = await xws(recallService).get(recallService.getPath(), {
        params: {
          locale,
          make,
          variant,
          webkey,
          day: formatDate(new Date(), 'YYYY/MM/DD')
        }
      });
      if (recallInfo) {
        return (
          recallInfo.autoRecalls.filter(
            recall =>
              ['COMPLETED', 'CLOSED'].indexOf(recall.status) === -1 &&
              recall.customerVisible
          ).length > 0
        );
      }
      return false;
    } catch (e) {
      return false;
    }
  }
  return false;
};

export const setRecallServices = recallServices => {
  return {
    type: SET_RECALL_SERVICES,
    payload: recallServices
  };
};



// WEBPACK FOOTER //
// ./src/store/reducers/recall/actions.js